import { CollectionEntity } from "@busy-human/gearbox";
export var Users;
(function (Users) {
    let UserType;
    (function (UserType) {
        UserType["SystemAdmin"] = "system-admin";
        UserType["Pilot"] = "pilot";
        UserType["Mechanic"] = "mechanic";
        UserType["Medic"] = "medCrew";
        UserType["CompanyAdmin"] = "company-admin";
        UserType["Admin"] = "admin";
        UserType["CommsSupervisor"] = "comms-supervisor";
        UserType["CommunicationCenterUser"] = "communicationCenterUser";
        UserType["CommsSpecialist"] = "comms-specialist";
        UserType["OCC"] = "occ";
        UserType["CrewUser"] = "crewUser";
        UserType["Ground"] = "ground";
    })(UserType = Users.UserType || (Users.UserType = {}));
    Users.UserTypeNameMap = {
        [UserType.SystemAdmin]: "System Admin",
        [UserType.Pilot]: "Pilot",
        [UserType.Mechanic]: "Mechanic",
        [UserType.Medic]: "Medic",
        [UserType.CompanyAdmin]: "Company Admin",
        [UserType.Admin]: "Admin",
        [UserType.CommsSupervisor]: "Communications Supervisor",
        [UserType.CommunicationCenterUser]: "Communications Specialist",
        [UserType.CommsSpecialist]: "Communications Specialist (deprecated)",
        [UserType.OCC]: "OCC",
        [UserType.CrewUser]: "Crew User (Med / Mechanic)",
        [UserType.Ground]: "Ground Crew"
    };
    const commsUserTypes = [
        UserType.SystemAdmin,
        UserType.CompanyAdmin,
        UserType.Admin,
        UserType.CommunicationCenterUser,
        UserType.CommsSpecialist,
        UserType.CommsSupervisor,
        UserType.OCC,
    ];
    function userTypeIsComm(type) {
        return commsUserTypes.includes(type);
    }
    Users.userTypeIsComm = userTypeIsComm;
    function resolveUserName(user) {
        if (!user)
            return "Unknown";
        if (user.type === Users.UserType.CrewUser)
            return user.username;
        return user.name.fullName;
    }
    Users.resolveUserName = resolveUserName;
    function UserDefaults() {
        return {
            name: null,
            type: null,
            phoneNumber: "",
            email: "",
            timestampCreated: new Date().toISOString(),
            timestampLastLogin: new Date().toISOString(),
            location: null,
        };
    }
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return UserDefaults();
        }
    }
    Users.CollectionClass = CollectionClass;
    // export const Users = new CollectionClass({ path: "/Users" });
})(Users || (Users = {}));
//# sourceMappingURL=index.js.map